// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import ReactVisibilitySensor from "react-visibility-sensor";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
function Prioritize2(Props) {
  var render = Props.render;
  var onPriorityChangeOpt = Props.onPriorityChange;
  var onPriorityChange = onPriorityChangeOpt !== undefined ? onPriorityChangeOpt : function (p) {};
  var match = ViewportContext$Showside.use(undefined);
  var match$1 = match.windowSize;
  var vh = match$1.height;
  var vw = match$1.width;
  var match$2 = React.useState(function () {
    return false;
  });
  var setVisibleCoarse = match$2[1];
  var isVisibleCoarse = match$2[0];
  var match$3 = React.useState(function () {
    return false;
  });
  var setVisibleFine = match$3[1];
  var isVisibleFine = match$3[0];
  var priority = isVisibleCoarse ? isVisibleFine ? 0 : 1 : 2;
  React.useEffect(function () {
    Curry._1(onPriorityChange, priority);
  }, [priority]);
  var offset_top = -vh | 0;
  var offset_left = -vw | 0;
  var offset_right = -vw | 0;
  var offset_bottom = -vh | 0;
  var offset = {
    top: offset_top,
    left: offset_left,
    right: offset_right,
    bottom: offset_bottom
  };
  var onChangeCoarse = function (nextIsVisible) {
    if (!isVisibleCoarse && nextIsVisible) {
      return Curry._1(setVisibleCoarse, function (param) {
        return true;
      });
    }
  };
  var onChangeFine = function (nextIsVisible) {
    if (!isVisibleFine && nextIsVisible) {
      return Curry._1(setVisibleFine, function (param) {
        return true;
      });
    }
  };
  var children = Curry._1(render, priority);
  return React.createElement(ReactVisibilitySensor, {
    partialVisibility: true,
    onChange: onChangeCoarse,
    children: React.createElement(ReactVisibilitySensor, {
      partialVisibility: true,
      onChange: onChangeFine,
      children: children
    }),
    offset: offset
  });
}
Prioritize2.displayName = "Prioritize2";
var make = Prioritize2;
export { make };
/* react Not a pure module */